import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const collapseDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Checks whether the component is expanded and the content is visible
     * @return {Promise<boolean>}
     */
    isOpen: async () => (await base.attr('data-open')) === 'true',
  };
};
